/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "cardio": {
            "nested": {
              "externalcardtransaction": {
                "nested": {
                  "TransactionType": {
                    "values": {
                      "TRANSACTION_TYPE_NOT_SPECIFIED": 0,
                      "PURCHASE": 1,
                      "BALANCE_INQUIRY": 2,
                      "FEE": 3,
                      "QUASI_CASH": 4,
                      "MERCHANDISE_RETURN": 5,
                      "ACCOUNT_CREDIT": 6,
                      "ACCOUNT_FUNDING": 7,
                      "CREDIT_ADJUSTMENT": 8,
                      "CASHBACK": 9,
                      "ATM_WITHDRAWAL": 10,
                      "DEBIT_ADJUSTMENT": 11,
                      "ATM_TRANSFER": 12
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.cardio?.nested?.externalcardtransaction?.nested?.TransactionType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TransactionType @ squareup/cash/cardio/api/transactions/ExternalCardTransaction.proto at 28:1
 */
export const TransactionType = $root.lookupEnum('squareup.cash.cardio.externalcardtransaction.TransactionType').values;